import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const quirkyMessages = [
  "That's tough.",
  "Why are you here?",
  "You've strayed too far.",
  "This page doesn't exist.",
  "You seem lost."
];

const NotFound = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * quirkyMessages.length);
    setMessage(quirkyMessages[randomIndex]);
  }, []);

  const handleClick = () => {
    if (authData && authData.isAuthenticated) {
      navigate('/home');
    } else {
      navigate('/login');
    }
  };

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1 style={{ fontSize: "6rem", margin: 0 }}>404</h1>
      <h2 style={{ margin: "0 0 1rem 0" }}>Not Found</h2>
      <img
        src="/bunny-fall.gif"
        alt="Bunny falling"
        style={{ width: "300px", height: "auto", margin: "1rem 0" }}
      />
      <p>{message}</p>
      <button className="btn btn-primary" onClick={handleClick}>
        Go Back to {authData && authData.isAuthenticated ? "Home" : "Login"}
      </button>
    </div>
  );
};

export default NotFound;